import React, { useState } from 'react';

interface SummonerSearchBarProps {
  onSearch: (region: string, gameName: string, tagLine: string) => void;
  defaultRegion?: string;
  compact?: boolean;
}

const REGIONS = [
  { value: 'euw', label: 'EUW' },
  { value: 'eune', label: 'EUNE' },
  { value: 'na', label: 'NA' },
  { value: 'kr', label: 'KR' },
  { value: 'jp', label: 'JP' },
  { value: 'br', label: 'BR' },
  { value: 'lan', label: 'LAN' },
  { value: 'las', label: 'LAS' },
  { value: 'oce', label: 'OCE' },
  { value: 'tr', label: 'TR' },
  { value: 'ru', label: 'RU' },
];

const SummonerSearchBar: React.FC<SummonerSearchBarProps> = ({
  onSearch,
  defaultRegion = 'euw',
  compact = false,
}) => {
  const [region, setRegion] = useState(defaultRegion);
  const [input, setInput] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const trimmed = input.trim();
    if (!trimmed) return;

    // Parse "GameName#TagLine" format
    const hashIndex = trimmed.lastIndexOf('#');
    if (hashIndex === -1) {
      // Default tagLine to region if not provided
      onSearch(region, trimmed, region.toUpperCase());
      return;
    }

    const gameName = trimmed.slice(0, hashIndex).trim();
    const tagLine = trimmed.slice(hashIndex + 1).trim();
    if (!gameName || !tagLine) return;

    onSearch(region, gameName, tagLine);
  };

  return (
    <form
      className={`summoner-search-bar ${compact ? 'search-compact' : ''}`}
      onSubmit={handleSubmit}
    >
      <select
        className="region-select"
        value={region}
        onChange={(e) => setRegion(e.target.value)}
      >
        {REGIONS.map((r) => (
          <option key={r.value} value={r.value}>
            {r.label}
          </option>
        ))}
      </select>
      <input
        type="text"
        className="summoner-input"
        placeholder="Game Name#Tag"
        value={input}
        onChange={(e) => setInput(e.target.value)}
      />
      <button type="submit" className="search-btn">
        Search
      </button>
    </form>
  );
};

export default SummonerSearchBar;
